import { render, staticRenderFns } from "./ForecastCanada.vue?vue&type=template&id=20758f04&scoped=true&"
import script from "./ForecastCanada.vue?vue&type=script&lang=js&"
export * from "./ForecastCanada.vue?vue&type=script&lang=js&"
import style0 from "./ForecastCanada.vue?vue&type=style&index=0&id=20758f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20758f04",
  null
  
)

export default component.exports